
  document.querySelectorAll('.prod-col-grid').forEach((item) => {
    item.addEventListener('click', function () {
      document.querySelectorAll('.prod-col-grid').forEach((el) => el.classList.remove('active'));
      this.classList.add('active');
      let colValue = this.getAttribute('data-col'); // Ensure correct attribute name
      // Set CSS variable on #product-card-grid
      document.getElementById('product-card-grid').style.setProperty('--products-per-row', colValue);
    });
  });
